// extracted by mini-css-extract-plugin
export default {"container":"StarredChannelEntries_container__dwM8N","entriesContainer":"StarredChannelEntries_entriesContainer__zbmc7","message":"StarredChannelEntries_message__hXD54"};